module.exports = __webpack_public_path__ + "img/lagoon_floorplan.f0a65126.svg";